import React from 'react';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { SEOHead } from '../components/SEOHead';
import { WhereToBuy } from '../components/WhereToBuy';
import { Distributors } from '../components/Distributors';
import { PointsOfSale } from '../components/PointsOfSale';
import { Products } from '../components/Products';

const SITE = process.env.REACT_APP_SITE_URL || 'https://cajeta-hacienda-real.com';

const storeSchema = (lang, region) => ({
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  '@id': `${SITE}/${region}/store/#webpage`,
  'url': `${SITE}/${region}/store`,
  'name': lang === 'es'
    ? 'Tienda – Cajeta Natural y Dulces de Leche de Vaca | Hacienda Real'
    : 'Store – Natural Cow\'s Milk Cajeta & Dairy Sweets | Hacienda Real',
  'description': lang === 'es'
    ? 'Compra cajeta natural de leche de vaca en línea. Cajeta tradicional, envinada y más productos artesanales sin conservadores. Envíos a México y Estados Unidos.'
    : 'Buy natural cow\'s milk cajeta online. Traditional, envinada and more artisan dairy products with no preservatives. Shipping to Mexico and the USA.',
  'isPartOf': { '@id': `${SITE}/#website` },
  'inLanguage': lang === 'es' ? 'es-MX' : 'en-US',
  'breadcrumb': {
    '@type': 'BreadcrumbList',
    'itemListElement': [
      {
        '@type': 'ListItem',
        'position': 1,
        'name': 'Hacienda Real',
        'item': `${SITE}/${region}`,
      },
      {
        '@type': 'ListItem',
        'position': 2,
        'name': lang === 'es' ? 'Tienda' : 'Store',
        'item': `${SITE}/${region}/store`,
      },
    ],
  },
});

export default function StorePage() {
  const { region = 'mx' } = useParams();
  const { lang } = useLanguage();

  const title = lang === 'es'
    ? 'Tienda – Cajeta Natural y Dulces de Leche de Vaca'
    : 'Store – Natural Cow\'s Milk Cajeta & Dairy Sweets';
  const description = lang === 'es'
    ? 'Compra cajeta natural de leche de vaca en línea: cajeta tradicional, envinada y más. Sin conservadores, receta original desde 1950. Disponible en Walmart, Mercado Libre, TikTok Shop y Bodega Aurrerá.'
    : 'Buy natural cow\'s milk cajeta online: traditional, envinada and more. No preservatives, original recipe since 1950. Available on TikTok Shop and Mercado Libre.';

  return (
    <>
      <SEOHead
        title={title}
        description={description}
        canonical={`/${region}/store`}
        lang={lang}
        altLang={{ es: '/mx/store', en: '/us/store' }}
        schema={storeSchema(lang, region)}
      />
      <Products />
      <WhereToBuy />
      <PointsOfSale />
      <Distributors />
    </>
  );
}
